import { TransactionHistory } from "redux/constants/TransactionHistory";

const initState = {
  data: [],
  loading: false,
};


const transactionHistory = (state = initState, action) => {
  switch (action.type) {
    case TransactionHistory.LOADING_TRANSACTIONHISTORY_LIST:
      return {
        ...state,
        loading: action.payload,
      };
    case TransactionHistory.GET_TRANSACTIONHISTORY_LIST:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default transactionHistory;
